import { Route } from "@angular/router";

import { checkIfLoggedInFn, pmoEntity } from "../../core/guards";
import { homepagePermissionGuard, isEntityDashboardGuard, isPMODashboardGuard } from "./_router.guards";
import { EntityComponent } from "./entity/entity";
import { ExecutiveDashboardComponent } from "./executive-dashboard/executive-dashboard";
import { NationalAgendaComponent } from "./national-agenda/national-agenda";
import { PmoComponent } from "./pmo/pmo";
import { SDG_ROUTES } from "./sdg/sdg-routes";

export const DASHBOARD_ROUTES: Route[] = [
  {
    path: "wtuae",
    component: NationalAgendaComponent,
    canActivate: [checkIfLoggedInFn, pmoEntity],
    data: {
      title: "national_agenda.main_dashboard.page_title",
      breadcrumb: "national_agenda.main_dashboard.page_title",
    },
  },
  {
    path: "executive-dashboard",
    component: ExecutiveDashboardComponent,
    canActivate: [checkIfLoggedInFn],
    data: {
      title: "executive_dashboard.title",
      breadcrumb: "executive_dashboard.title",
    },
  },
  {
    path: "dashboard/target",
    component: PmoComponent,
    canActivate: [checkIfLoggedInFn, homepagePermissionGuard, isPMODashboardGuard],
    data: {
      title: "navigation.home",
      breadcrumb: "navigation.home",
      isPmoDashboard: true,
    },
  },
  {
    path: "dashboard/entity",
    component: EntityComponent,
    canActivate: [checkIfLoggedInFn, homepagePermissionGuard, isEntityDashboardGuard],
    data: {
      title: "landingPage.menu.entity",
      breadcrumb: "landingPage.menu.entity",
      isPmoDashboard: false,
    },
  },
  ...SDG_ROUTES,
];
